// extracted by mini-css-extract-plugin
module.exports = {"NavigationItem":"NavigationItem_NavigationItem__1JYfo","active":"NavigationItem_active__3OWkJ"};